import { observer } from "mobx-react-lite"
import React, { useMemo } from "react"
import { Result } from "../../shared/ui/Result"

// ----------------------------------------------------------------------

type Props = {
  isEmpty: boolean
  isLoading?: boolean
  error: string | null
  children: React.ReactNode
  loadingComponent?: React.FC<unknown>
}

export const ResultWrapper = observer(function ResultWrapper(
  {
    loadingComponent,
    isLoading,
    error,
    isEmpty,
    children,
  }: Props) {

  const Loader = useMemo(function () {
    return loadingComponent
  }, [ loadingComponent ])

  if (isLoading) {
    return Loader ? <Loader/> : <Result type="loading"/>
  }

  if (error) {
    return (
      <Result type="error" title="Ошибка загрузки данных" message={error}/>
    )
  }

  if (isEmpty) {
    return (
      <Result type="empty" title="Ничего не найдено" message="Попробуйте изменить параметры запроса"/>
    )
  }

  return <>{children}</>
})
